"use client"

import { ChartPie } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ChartPieIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ChartPieIcon = component(Icon)({ as: ChartPie })
